import { useEffect } from "react";

export function useSiteTopHeight(selector = ".site-top-fixed") {
    useEffect(() => {
        const element = document.querySelector(selector);
        if (!element) {
            return undefined;
        }

        const update = () => {
            const height = `${element.offsetHeight}px`;
            document.documentElement.style.setProperty("--site-header-height", height);
            document.documentElement.style.setProperty("--site-top-spacer-height", height);
            document.documentElement.style.setProperty("--site-sticky-top", height);
        };

        update();
        const observer = new ResizeObserver(update);
        observer.observe(element);
        window.addEventListener("resize", update);

        return () => {
            observer.disconnect();
            window.removeEventListener("resize", update);
        };
    }, []);
}
